import validate from "/var/www/projects/hillceramic.se/releases/20261105081705Z/node_modules/nuxt/dist/pages/runtime/validate.js";
import review_45query_45global from "/var/www/projects/hillceramic.se/releases/20261105081705Z/middleware/review-query.global.js";
export const globalMiddleware = [
  validate,
  review_45query_45global
]
export const namedMiddleware = {
  "prefetch-page": () => import("/var/www/projects/hillceramic.se/releases/20261105081705Z/middleware/prefetch-page.ts")
}